<template>
  <div
      class="v-sidebar-menu"
      :class="sidebarClass"
      :style="[{'max-width': sidebarWidth, 'margin-top': notification ? '-100px' : '0'}]"
      @mouseleave="onMouseLeave"
  >
    <slot name="header" />
    <div
        class="vsm--scroll-wrapper"
        :style="isCollapsed && [rtl ? {'margin-left': '-17px'} : {'margin-right': '-17px'}]"
    >
      <div
          class="vsm--list"
          :style="isCollapsed && {'width': widthCollapsed}"
      >
        <sidebar-menu-item
            v-for="(item, index) in menu"
            :key="index"
            :item="item"
            :is-collapsed="isCollapsed"
            :active-show="activeShow"
            :show-one-child="showOneChild"
            :show-child="item.showChild ? item.showChild : showChild"
            :rtl="rtl"
            :mobile-item="mobileItem"
            :disable-hover="disableHover"
            @set-mobile-item="setMobileItem"
            @unset-mobile-item="unsetMobileItem"
        >
          <slot
              slot="dropdown-icon"
              name="dropdown-icon"
          />
        </sidebar-menu-item>
      </div>
      <div
          v-if="isCollapsed"
          class="vsm--mobile-item"
          :style="mobileItemStyle.item"
      >
        <sidebar-menu-item
            v-if="mobileItem"
            :item="mobileItem"
            :is-mobile-item="true"
            :mobile-item-style="mobileItemStyle"
            :is-collapsed="isCollapsed"
            :show-child="showChild"
            :rtl="rtl"
        >
          <slot
              slot="dropdown-icon"
              name="dropdown-icon"
          />
        </sidebar-menu-item>
        <transition name="slide-animation">
          <div
              v-if="mobileItem"
              class="vsm--mobile-bg"
              :style="mobileItemStyle.background"
          />
        </transition>
      </div>
      <div class="admin-chat">
        <div class="chat-tooltip">
          <button class="vsm--scroll-wrapper-write " @click="$refs.questionModal.open()">

            <img src="@/assets/img/sidebar/chat.svg" alt=""/>
          </button>
          <div class="left">
            <span><b>Написать в техподдержку</b></span>
            <i></i>
          </div>
        </div>
      </div>

      <admin-question-modal ref="questionModal"/>
      <div style="max-height: 400px;overflow: hidden;    margin-top: 20px;" v-if="banner !== ''">
        <a :href="bannerUrl">
            <img style="width: 100%;height: 100%;object-fit: cover;" :src="banner">
        </a>
      </div>
      </div>
    <transition name="fade-parts">
      <!--<div class="vsm&#45;&#45;footer">
        Наши партнеры
      </div>-->
    </transition>

<!--    <button-->
<!--        v-if="!hideToggle"-->
<!--        class="vsm&#45;&#45;toggle-btn"-->
<!--        :class="{'vsm&#45;&#45;toggle-btn_slot' : $slots['toggle-icon']}"-->
<!--        @click="onToggleClick"-->
<!--    >-->
<!--      <slot name="toggle-icon" />-->
<!--    </button>-->

  </div>
</template>

<script>
import SidebarMenuItem from './SidebarMenuItem.vue'
import AdminQuestionModal from "@/components/modals/admin-question-modal";

export default {
  name: 'SidebarMenu',
  components: {
    SidebarMenuItem,
    AdminQuestionModal
  },
  props: {
    menu: {
      type: Array,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '350px'
    },
    widthCollapsed: {
      type: String,
      default: '50px'
    },
    showChild: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: ''
    },
    showOneChild: {
      type: Boolean,
      default: false
    },
    rtl: {
      type: Boolean,
      default: false
    },
    relative: {
      type: Boolean,
      default: false
    },
    hideToggle: {
      type: Boolean,
      default: false
    },
    disableHover: {
      type: Boolean,
      default: false
    },
    notification: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCollapsed: this.collapsed,
      mobileItem: null,
      mobileItemPos: 0,
      mobileItemHeight: 0,
      mobileItemTimeout: null,
      activeShow: null,
      parentHeight: 0,
      parentWidth: 0,
      parentOffsetTop: 0,
      parentOffsetLeft: 0,
      banner: '',
      bannerUrl: ''
    }
  },
  computed: {
    sidebarWidth () {
      return this.isCollapsed ? this.widthCollapsed : this.width
    },
    sidebarClass () {
      return [
        !this.isCollapsed ? 'vsm_expanded' : 'vsm_collapsed',
        this.theme ? `vsm_${this.theme}` : '',
        this.rtl ? 'vsm_rtl' : '',
        this.relative ? 'vsm_relative' : ''
      ]
    },
    mobileItemStyle () {
      return {
        item: [
          { 'position': 'absolute' },
          { 'top': `${this.mobileItemPos}px` },
          this.rtl ? { 'right': '0px' } : { 'left': '0px' },
          this.rtl ? { 'padding-right': this.sidebarWidth } : { 'padding-left': this.sidebarWidth },
          this.rtl && { 'direction': 'rtl' },
          { 'z-index': 0 },
          { 'width': `${this.parentWidth - this.parentOffsetLeft}px` },
          { 'max-width': `calc(${this.width} + ${this.widthCollapsed})` }
        ],
        dropdown: [
          { 'position': 'absolute' },
          { 'top': `${this.mobileItemHeight}px` },
          { 'width': '100%' },
          { 'max-height': `${this.parentHeight - (this.mobileItemPos + this.mobileItemHeight) - this.parentOffsetTop}px` },
          { 'overflow-y': 'auto' }
        ],
        background: [
          { 'position': 'absolute' },
          { 'top': '0px' },
          { 'left': '0px' },
          { 'right': '0px' },
          { 'width': '100%' },
          { 'height': `${this.mobileItemHeight}px` },
          { 'z-index': -1 }
        ]
      }
    }
  },
  watch: {
    collapsed (val) {
      if (this.isCollapsed === this.collapsed) return
      this.isCollapsed = val
      this.mobileItem = null
    }
  },
  mounted() {
    this.$http.post('/get-banner', {
      type:1,
    }).then(({data})=> {
      this.banner = data[0].path
      this.bannerUrl = data[0].url
      console.log(data)
    });
  },
  methods: {
    onMouseLeave () {
      this.mobileItem = null
    },
    onToggleClick () {
      this.isCollapsed = !this.isCollapsed
      this.mobileItem = null
      this.$emit('toggle-collapse', this.isCollapsed)
    },
    onActiveShow (item) {
      this.activeShow = item
    },
    onItemClick (event, item, node) {
      this.$emit('item-click', event, item, node)
    },
    setMobileItem ({ item, itemEl }) {
      if (this.mobileItem === item) return
      let sidebarTop = this.$el.getBoundingClientRect().top
      let itemTop = itemEl.getBoundingClientRect().top
      let itemLinkEl = itemEl.children[0]

      let styles = window.getComputedStyle(itemEl)
      let paddingTop = parseFloat(styles.paddingTop)
      let marginTop = parseFloat(styles.marginTop)

      let height = itemLinkEl.offsetHeight
      let positionTop = itemTop - sidebarTop + paddingTop + marginTop

      this.initParentOffsets()
      this.mobileItem = item
      this.mobileItemPos = positionTop
      this.mobileItemHeight = height
    },
    unsetMobileItem (immediate) {
      if (!this.mobileItem) return
      if (this.mobileItemTimeout) clearTimeout(this.mobileItemTimeout)
      if (immediate) {
        this.mobileItem = null
        return
      }
      this.mobileItemTimeout = setTimeout(() => {
        this.mobileItem = null
      }, 600)
    },
    initParentOffsets () {
      let { top: sidebarTop, left: sidebarLeft, right: sidebarRight } = this.$el.getBoundingClientRect()
      let parent = this.relative ? this.$el.parentElement : document.documentElement
      this.parentHeight = parent.clientHeight
      this.parentWidth = parent.clientWidth
      if (this.relative) {
        let { top: parentTop, left: parentLeft } = parent.getBoundingClientRect()
        this.parentOffsetTop = sidebarTop - (parentTop + parent.clientTop)
        this.parentOffsetLeft = this.rtl ? this.parentWidth - sidebarRight + (parentLeft + parent.clientLeft) : sidebarLeft - (parentLeft + parent.clientLeft)
      } else {
        this.parentOffsetTop = sidebarTop
        this.parentOffsetLeft = this.rtl ? this.parentWidth - sidebarRight : sidebarLeft
      }
    },
    onItemUpdate (newItem, item) {
      if (item === this.mobileItem) {
        this.mobileItem = newItem
      }
      if (item === this.activeShow) {
        this.activeShow = newItem
      }
    }
  },
  provide () {
    return {
      emitActiveShow: this.onActiveShow,
      emitItemClick: this.onItemClick,
      emitItemUpdate: this.onItemUpdate
    }
  }
}
</script>

<style scoped>
.admin-chat {
  position: fixed;
  right: 10px;
  bottom: 0px;
}
.chat-tooltip {
  display:inline-block;
  position:relative;
  border-bottom:1px dotted #666;
  text-align:left;
}

.left {
  min-width:220px;
  top:50%;
  right:100%;
  margin-right:10px;
  transform:translate(0, -50%);
  padding:10px 20px;
  color:#444444;
  background-color:#FFFFFF;
  font-weight:normal;
  font-size:13px;
  border-radius:8px;
  position:absolute;
  z-index:99999999;
  box-sizing:border-box;
  border:2px solid #2CB181;
  box-shadow:0 1px 8px rgba(0,0,0,0.5);
  transition:opacity 0.8s;
  visibility:hidden;
  opacity:0;
}

.chat-tooltip:hover .left {
  visibility:visible; opacity:1;
}

.chat-tooltip .left i {
  position:absolute;
  top:50%;
  left:100%;
  margin-top:-12px;
  width:12px;
  height:24px;
  overflow:hidden;
}

.chat-tooltip .left i::after {
  content:'';
  position:absolute;
  width:12px;
  height:12px;
  left:0;
  top:50%;
  transform:translate(-50%,-50%) rotate(-45deg);
  background-color:#FFFFFF;
  border:2px solid #2CB181;
  box-shadow:0 1px 8px rgba(0,0,0,0.5);
}
</style>

<style lang="scss">
$primary-color: #2cb181 !default;
$base-bg: #fff !default;

$item-color: #7A818F !default;

$item-active-color: null !default;
$item-active-bg: #F9F9FB !default;

$item-open-color: $item-color !default;
$item-open-bg: #f9f9fb !default;

$item-hover-color: null !default;
$item-hover-bg: rgba(darken($base-bg, 5%), 0.5) !default;

$icon-color: null !default;
$icon-bg: darken( $base-bg, 5% ) !default;

$icon-active-color: null !default;
$icon-active-bg: null !default;

$icon-open-color: null !default;
$icon-open-bg: $item-open-bg !default;

$mobile-item-color: $item-color !default;
$mobile-item-bg: #F9F9FB !default;
$mobile-icon-color: $mobile-item-color !default;
$mobile-icon-bg: #F9F9FB !default;

$dropdown-bg: #F9F9FB !default;
$dropdown-color: null !default;

$item-font-size: 16px !default;
$item-line-height: 20px !default;
$item-padding: 10px 15px !default;
$icon-height: 20px !default;
$icon-width: 20px !default;

.fade-parts-enter-active, .fade-parts-leave-active {
  transition: opacity .2s;
}
.fade-parts-enter, .fade-parts-leave-to {
  position: absolute;
  opacity: 0;
}

.v-sidebar-menu {
  * {
    box-sizing: border-box;
  }
  margin-top: -90px;
  border-right: 1px solid #EEF0F3;
  top:50px;
  height: calc(100vh - 50px);
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  transition: 0.3s max-width ease;

  .vsm--scroll-wrapper {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;

    &-write {
      background: #2CB181;
      border: none;
      outline: none;
      width: 45px;
      height: 45px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 20px auto;

      > img {
        margin-left: 2px;
        width: 23px;
        height: 21px;
      }
    }
  }

  .vsm--dropdown > .vsm--list {
    padding: 0;
  }
  .vsm--dropdown > .vsm--list >.vsm--item:last-child {
    border-bottom: unset;
  }

  .vsm--item {
    position: relative;
    display: block;
    width: 100%;
    white-space: nowrap;
    border-bottom: 1px solid #EEF0F3;
  }
  .vsm--footer{
    min-width: 200px;
    border-top: 1px solid #EEF0F3;
    padding: 12px 16px;
  }
  .vsm--link {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    font-size: $item-font-size;
    font-weight: 400;
    padding: $item-padding;
    line-height: $item-line-height;
    text-decoration: none;
    user-select: none;
    z-index: 20;
    transition: 0.3s all ease;
    &_exact-active,
    &_active {
      font-weight: 600;
    }
    &_disabled {
      opacity: 0.4;
      pointer-events: none;
    }
    &_level-1 {
      .vsm--icon {
        height: $icon-height;
        line-height: $icon-height;
        width: $icon-width;
        flex-shrink: 0;
        text-align: center;
        border-radius: 3px;
        transition: margin-left 0.1s, margin-right 0.1s;
      }
    }
    &_mobile-item {
      background-color: transparent !important;
    }
  }

  .vsm--title {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    margin-left: 10px;
    flex-grow: 1;
  }

  .vsm--arrow {
    width: 9px;
    transition: 0.3s transform ease;
    &_open {
      transform: rotate(90deg);
    }
  }

  .vsm--header {
    font-size: 14px;
    font-weight: 600;
    padding: 10px;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .vsm--badge {
    &_default {
      padding: 0px 6px;
      font-size: 12px;
      border-radius: 3px;
      height: 20px;
      line-height: 20px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }

  .vsm--toggle-btn {
    display: block;
    text-align: center;
    font-style: normal;
    font-weight: 900;
    height: 50px;
    cursor: pointer;
    border: none;
    width: 100%;
    &:after {
      content: '\f337';
      font-family: 'Font Awesome 5 Free';
    }
    &_slot:after {
      display: none;
    }
  }

  &.vsm_collapsed {
    .vsm--scroll-wrapper-write{
      transform: translateX(-9px);
    }
    .vsm--footer{
      opacity: 0;
    }
    & .vsm--link_level-1 {
      &.vsm--link_hover,
      &:hover {
        background-color: transparent !important;
      }
    }
  }

  &.vsm_rtl {
    right: 0;
    left: inherit;
    text-align: right;
    direction: rtl;

    & .vsm--icon {
      margin-left: 10px;
      margin-right: 0px;
    }
  }

  &.vsm_relative {
    position: relative;
    height: 100%;
  }

  .expand-enter-active,
  .expand-leave-active {
    transition: height 0.3s ease;
    overflow: hidden;
  }
  .expand-enter,
  .expand-leave-to {
    height: 0 !important;
  }

  .slide-animation-enter-active {
    transition: width 0.3s ease;
  }
  .slide-animation-leave-active {
    transition: width 0.3s ease;
  }
  .slide-animation-enter,
  .slide-animation-leave-to {
    width: 0 !important;
  }

  .fade-animation-enter-active {
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  .fade-animation-leave-active {
    transition: opacity 0.3s ease, visibility 0.3s ease;
  }
  .fade-animation-enter,
  .fade-animation-leave-to {
    opacity: 0 !important;
    visibility: hidden !important;
  }

  .vsm--mobile-item >.vsm--item {
    width: 100%;
    display: flex;
    align-items: center;
    height: 41px;
    padding: 0 !important;
    margin: 0 !important;
  }
  .vsm--mobile-item >.vsm--item> a> .vsm--title,
  .vsm--mobile-item>.vsm--item>.vsm--link {
    width: 100%;
    margin: 0 !important;
  }
}

.v-sidebar-menu {
  background-color: $base-bg;
  .vsm--link {
    color: $item-color;
    &_exact-active,
    &_active {
      color: $item-active-color;
      background-color: $item-active-bg;
    }
    &_level-1 {
      &.vsm--link_exact-active,
      &.vsm--link_active {
        box-shadow: 3px 0px 0px 0px $primary-color inset;
        & .vsm--icon {
          color: $icon-active-color;
        }
      }
    }
    &_hover,
    &:hover {
      color: $item-hover-color;
      background-color: $item-hover-bg;
    }
    &_mobile-item {
      color: $mobile-item-color;
      &.vsm--link_hover,
      &:hover {
        color: $mobile-item-color;
      }
    }
  }

  &.vsm_collapsed {
    .vsm--link_level-1.vsm--link_hover,
    .vsm--link_level-1:hover {
      .vsm--icon {
        color: $mobile-icon-color;
      }
    }
  }

  .vsm--icon {
    color: $icon-color;
  }

  .vsm--dropdown {
    & .vsm--list {
      background-color: $dropdown-bg;
    }
    & .vsm--link {
      color: $dropdown-color;
    }
    & .vsm--icon {
      color: $dropdown-color;
    }
  }

  .vsm--mobile-bg {
    background-color: $mobile-item-bg;
  }

  &.vsm_expanded {
    .vsm--item_open {
      .vsm--link {
        &_level-1 {
          color: $item-open-color;
          background-color: $item-open-bg;
          & .vsm--icon {
            color: $icon-open-color;
          }
        }
      }
    }
  }

  &.vsm_rtl {
    .vsm--link_level-1.vsm--link_active,
    .vsm--link_level-1.vsm--link_exact-active {
      box-shadow: -3px 0px 0px 0px $primary-color inset;
    }
  }

  .vsm--header {
    color: rgba($item-color, 0.7);
  }
  .vsm--badge_default {
    color: $item-color;
    background-color: darken( $base-bg, 5% );
  }
  .vsm--toggle-btn {
    color: $item-color;
    background-color: darken( $base-bg, 5% );
  }
}
.v-sidebar-menu .vsm--scroll-wrapper-write:hover{
  background-color: #238d67;
}

</style>
